import { getType, getActionCreator } from 'shared/lib';
const prefix = '@@app/Salary';

export const SET_MODAL_VISIBILITY = getType(prefix, 'SET_MODAL_VISIBILITY');
export const setSalaryModalVisibility = getActionCreator(SET_MODAL_VISIBILITY);

export const SEND_EXCO_INFO_REQUEST = getType(prefix, 'SEND_EXCO_INFO_REQUEST');
export const sendExcoInfoRequest = getActionCreator(SEND_EXCO_INFO_REQUEST);

export const SEND_EXCO_INFO_BY_EMPLOYEE_REQUEST = getType(
  prefix,
  'SEND_EXCO_INFO_BY_EMPLOYEE_REQUEST'
);
export const sendExcoInfoByEmployeeRequest = getActionCreator(
  SEND_EXCO_INFO_BY_EMPLOYEE_REQUEST
);

export const SEND_EXCO_INFO_SUCCESS = getType(prefix, 'SEND_EXCO_INFO_SUCCESS');
export const sendExcoInfoSuccess = getActionCreator(SEND_EXCO_INFO_SUCCESS);

export const SEND_EXCO_INFO_ERROR = getType(prefix, 'SEND_EXCO_INFO_ERROR');
export const sendExcoInfoError = getActionCreator(SEND_EXCO_INFO_ERROR);

export const GET_EXCO_INFO_MODAL_DATA_REQUEST = getType(
  prefix,
  'GET_EXCO_INFO_MODAL_DATA_REQUEST'
);
export const getExcoInfoModalDataRequest = getActionCreator(
  GET_EXCO_INFO_MODAL_DATA_REQUEST
);

export const GET_EMPLOYEE_EXCO_INFO_MODAL_DATA_REQUEST = getType(
  prefix,
  'GET_EMPLOYEE_EXCO_INFO_MODAL_DATA_REQUEST'
);
export const getEmployeeExcoInfoModalDataRequest = getActionCreator(
  GET_EMPLOYEE_EXCO_INFO_MODAL_DATA_REQUEST
);

export const GET_EXCO_INFO_MODAL_DATA_SUCCESS = getType(
  prefix,
  'GET_EXCO_INFO_MODAL_DATA_SUCCESS'
);
export const getExcoInfoModalDataSuccess = getActionCreator(
  GET_EXCO_INFO_MODAL_DATA_SUCCESS
);

export const RESET_EXCO_INFO_MODAL_DATA = getType(
  prefix,
  'RESET_EXCO_INFO_MODAL_DATA'
);
export const resetExcoInfoModalData = getActionCreator(
  RESET_EXCO_INFO_MODAL_DATA
);

export const GET_CHECK_PENDING_CHANGES_REQUEST = getType(
  prefix,
  'GET_CHECK_PENDING_CHANGES_REQUEST'
);
export const getCheckPendingChanges = getActionCreator(
  GET_CHECK_PENDING_CHANGES_REQUEST
);

export const GET_CHECK_PENDING_CHANGES_SUCCESS = getType(
  prefix,
  'GET_CHECK_PENDING_CHANGES_SUCCESS'
);
export const getCheckPendingChangesSuccess = getActionCreator(
  GET_CHECK_PENDING_CHANGES_SUCCESS
);

export const SET_MODAL_EMPLOYEE = getType(prefix, 'SET_MODAL_EMPLOYEE');
export const setSalaryModalEmployee = getActionCreator(SET_MODAL_EMPLOYEE);

export const SET_PENDING_CHANGES_LOADING = getType(
  prefix,
  'SET_PENDING_CHANGES_LOADING'
);
export const setPendingChangesLoading = getActionCreator(
  SET_PENDING_CHANGES_LOADING
);
